export default __webpack_public_path__ + "static/media/ro.647d3298.svg";